import { type SurgicalGuideOrder, SurgicalGuideOrderState } from '@/stores/surgicalGuideOrders/types';
import type { ApiSurgicalGuideOrder } from '@/stores/surgicalGuideOrders/api';


export function mapToStateOrder(apiOrder: ApiSurgicalGuideOrder): SurgicalGuideOrder {
    return {
        id: apiOrder.id,
        caseId: apiOrder.case_id,
        planId: apiOrder.plan_id,
        state: apiOrder.state as SurgicalGuideOrderState,
        scansLastDownloadedAt: apiOrder.scans_last_downloaded_at,
        modelsLastDownloadedAt: apiOrder.models_last_downloaded_at,
    };
}
